import logo from "./logo.png";
import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer>
          This project was coded by{" "}
          <a
            href="https://www.shecodes.io/graduates/97951-gaelle-petzi-tiepmo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>Gaelle Petzi Tiepmo</strong>.
          </a>{" "}
          This project is{" "}
          <a
            href="https://github.com/OnwardForward/dictionary-project"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on <strong>GitHub</strong>
          </a>{" "}
          and{" "}
          <a
            href="https://react-dictionary-gaellept.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            and is hosted on <strong>Netlify</strong>.
          </a>
        </footer>
      </div>
    </div>
  );
}
